<template>
  <div class="container">
    <div class="content">
      <h2>🐾 9 Lives of Employment: Where Your Wealth Journey Truly Begins! 🐾</h2>
      <p> 🎩 You know, in the feline world, we don't usually work—our humans serve us, right? But let's be honest, the closest thing we cats get to "work" is deciding whether to nap on the couch or the bed. 😺

Now, let's talk about you. You've got something we cats don't—a job! And that's your first step toward becoming financially purr-sistent. 

<br><br>💼 Your Job Matters: Whether you're a freelancer juggling gigs or a full-timer climbing the corporate ladder, what you do for a living is the cornerstone of your financial life.

<br><br>📈 The Long Game: Remember, Rome wasn't built in a day, and neither is wealth. Your income, when managed wisely, is like a snowball—it'll grow bigger and faster as it rolls down the hill of time.

<br><br>🤑 Invest in You: While it's great to invest in stocks or real estate, don't forget to invest in yourself. Upskill, network, and seize opportunities. Your income potential is a goldmine waiting to be tapped!

The more we know, the better we can tailor advice to help you make the most of your earnings.<br><br>

Remember get-rich-quick schemes and hot investment tips are tempting (just like that red laser dot we can never catch 🐾). But the real ticket to building lasting wealth? It's your regular, everyday income along with your spending habits.</p>

<br>Please select all that apply.  I know my hooman was always busy working, studying and still having time for some fun. <br><br>

      <div class="option" @click="toggleOption('employed')" :class="{ selected: isSelected('employed') }">
        <span class="icon">💰 </span>
        <b>Get that cheese - The 9-to-5 Mouse Hunter</b> Prowling through the daily grind, you're the savvy feline of the corporate jungle. Like a keen-eyed cat stalking the elusive mouse, you navigate the work world with purr-cision and grace.
      </div>

      <div class="option" @click="toggleOption('student')" :class="{ selected: isSelected('student') }">
        <span class="icon">🚙</span>
        <b>The Knowledge Kitten</b> Curiosity didn't just intrigue the cat – it made the cat smarter! As a Knowledge Kitten, you're whisker-deep in books, exploring the vast landscape of learning. Each page turned is a paw step forward in your quest for wisdom. Keep pouncing on that knowledge – the world is your scratching post!
      </div>

      <div class="option" @click="toggleOption('entrepreneur')" :class="{ selected: isSelected('entrepreneur') }">
        <span class="icon">🐈</span>
        <b>The Venture Pawspreneur</b> As the Venture Pawspreneur, you're not just chasing yarn – you're spinning it into gold! With the agility of a cat leaping towards its goals, you turn dreams into reality. Each risk is a leap onto a new ledge, and each success a purr-worthy achievement. In the land of business, you're the cat that got the cream!
      </div>

      <div class="option" @click="toggleOption('retired')" :class="{ selected: isSelected('retired') }">
        <span class="icon">🛂 </span>
        <b>The Leisure Lion </b> Retirement – the long-awaited catnap after years of prowling and leaping. As the Leisure Lion, you bask in the sunbeam of relaxation, savoring the sweet nectar of a life well-lived. Your days are now for stretching, yawning, and indulging in your favorite pastimes. After all, every wise cat knows the best moments are those spent in contented repose.
      </div>

      <div class="option" @click="toggleOption('like-a-cat')" :class="{ selected: isSelected('like-a-cat') }">
        <span class="icon">🪦</span>
        <b>The Pampered Purrball</b> In the cozy lap of luxury, you're living the ultimate cat dream! As the Pampered Purrball, you know there’s an art to being cared for and adored. Why chase mice when you can charm and be charmed? Remember, it’s not just about enjoying the good life – it's about purring with gratitude for every stroke of fortune.
</div>
      

  
    </div>
  </div><br><br><br><br><br><br>
</template>


<script>
import { onboardingStore } from '@/components/stores/onboardingStore';

export default {
  setup() {
    const store = onboardingStore();

    const toggleOption = (option) => {
      const currentStatuses = store.formData.employment_status;
      const index = currentStatuses.indexOf(option);

      if (index === -1) {
        // If not selected, add it to the array
        store.updateFormData({ employment_status: [...currentStatuses, option] });
      } else {
        // If already selected, remove it from the array
        const updatedStatuses = currentStatuses.filter(item => item !== option);
        store.updateFormData({ employment_status: updatedStatuses });
      }
    };

    // Helper method to check if an option is selected
    const isSelected = (option) => store.formData.employment_status.includes(option);

    return { store, toggleOption, isSelected };
  },
};
</script>






<style scoped>
.container {
  background-color: #4A148C; 
 color: black;
 padding: 20px;
 border-radius: 20px;
 display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 300px;
  max-width: 800px; /* Set a maximum width */
  align-items: center; /* Centered alignment */
  margin: auto; /* Center the container on the page */
  margin-top: 0; /* Adjusted as per your requirement */
}

.content {
background-color: white;
padding: 20px;
border-radius: 10px;
color: black;
}

.option {
padding: 10px;
border: 1px solid #ccc;
border-radius: 10px;
text-align: center;
box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
cursor: pointer;
transition: transform 0.3s ease, box-shadow 0.3s ease;
margin-bottom: 10px;
}

.option:hover {
transform: translateY(-5px);
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}


.selected {
background-color: #4A148C; /* More solid color for selection */
color: white;
}


.icon {
font-size: 24px; /* Larger icon size */
}

/* Additional style if needed */
</style>